import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css'
import App from './App';

const app = (
  <HashRouter basename="/renet">
    <App exact path='/' />
  </HashRouter>
);

ReactDOM.render(app, document.getElementById('root'));